import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import UploadFilesForRemap from '../../components/adminTools/uploadFilesForRemap';
import InputHeader from '../../components/global/inputwithHeader';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import _ from 'lodash';
const remapAsset = gql`
	mutation RootMutation($identifier: ID!, $newQrCode: String!) {
		remapAsset(identifier: $identifier, newQrCode: $newQrCode) {
			id
		}
	}
`;
const getAsset = gql`
	query Asset($identifier: ID!) {
		asset(identifier: $identifier) {
			qrCode
			serialNumber
			type
			employees {
				_id
				designation
				name
			}
		}
	}
`;
class RemapAsset extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: false,
			newQrCode: '',
			oldQrCode: '',
			oldSerialNumber: '',
			newSerialNumber: '',
			assetDetails: {},
			isAssetFetching: false,
			qrCodeError: false,
			qrCodeErrorMessage: '',
			assetFetched: false,
			isAPILoading: false,
		};
	}
	isDisabled = () => {
		if (
			this.state.newQrCode == '' ||
			this.state.oldQrCode == '' ||
			(this.state.newQrCode &&
				this.state.oldQrCode &&
				this.state.newQrCode === this.state.oldQrCode) ||
			this.state.newQrCode.length !== 8 ||
			this.state.oldQrCode.length < 4 ||
			this.state.isAPILoading === true
		) {
			return true;
		} else {
			return false;
		}
	};
	handleRemapAsset = () => {
		let json;
		json = {
			identifier: this.state.oldQrCode,
			newQrCode: this.state.newQrCode,
		};

		this.remapAsset(remapAsset, json);
	};
	handleQrCode = (e, type) => {
		if (type === 'oldQrCode') {
			this.setState({
				assetFetched: false,
				qrCodeError: false,
				isAssetFetching: false,
			});
		}
		this.setState(
			{
				[type]: e.target.value,
			},
			async () => {
				if (type === 'oldQrCode' && e.target.value.length >= 4) {
					let json = { identifier: e.target.value };

					await this.getAssetInfo(getAsset, json, null, true);
				}
			},
		);
	};
	render() {
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div
						className="assign-receive-container"
						style={{ width: '100%', marginLeft: 0 }}
					>
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div>
							<div className="arch-item">
								<span>Admin Tools</span>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>

							<div className="arch-item">
								<span>Remapping Asset</span>
							</div>
							<div className="actn-btn">
								<a
									onClick={(e) => {
										if (!this.isDisabled()) {
											/* this.setState({
												isAPILoading: true,
											}); */
											// if (false && this.state.beforeFileCount > 0) {
											// 	this.setState({ uploadBeforeFiles: true });
											// } else if (false && this.state.afterFileCount > 0) {
											// 	this.setState({ uploadAfterFiles: true });
											// } else {
											this.handleRemapAsset();
											// }
										}
									}}
									className={this.isDisabled() ? 'isDisabledBtn' : ''}
								>
									Remap Asset
								</a>
							</div>
						</div>
						<div className="arc-body">
							<div className="remap-equipment-container">
								<div className="rec-left">
									<InputHeader
										type="text"
										name="oldQrCode"
										isInputError={false}
										label="Enter QR Code (old) or Serial Number"
										value={this.state.oldQrCode}
										width="100%"
										onChange={(e) => this.handleQrCode(e, 'oldQrCode')}
										readOnly={this.state.isAPILoading}
									/>

									{/* {this.state.oldQrCode !== '' &&
									this.state.qrCodeError !== true &&
									this.state.eqFetched ? ( */}
									<InputHeader
										type="text"
										name="newQrCode"
										isInputError={false}
										label="Enter QR Code (new)"
										value={this.state.newQrCode}
										width="100%"
										onChange={(e) => this.handleQrCode(e, 'newQrCode')}
										readOnly={this.state.isAPILoading}
									/>
									{/* ) : (
										''
									)} */}

									<div className="remap-eq-summary">
										{this.state.isAssetFetching ? (
											'Loading...'
										) : this.state.assetFetched ? (
											this.state.qrCodeError == false ? (
												<>
													<b>Old Qr Code Details:</b>
													<a>
														Qr Code :{' '}
														<b>{this.state.assetDetails.qrCode}</b>
													</a>
													<a>
														Serial Number :{' '}
														<b>
															{this.state.assetDetails.serialNumber}
														</b>
													</a>
													<a>
														Type : <b>{this.state.assetDetails.type}</b>
													</a>
												</>
											) : (
												<p>Asset Not Found</p>
											)
										) : (
											''
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}
export default withRouter(RemapAsset);
